var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIconPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phone",
    clipPath: "url(#clip0_6191_15481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5587 10.2189C11.6366 10.1671 11.7262 10.1355 11.8194 10.127C11.9125 10.1186 12.0064 10.1335 12.0923 10.1704L15.4083 11.6561C15.52 11.7039 15.6133 11.7865 15.6741 11.8917C15.735 11.997 15.7601 12.119 15.7458 12.2397C15.6365 13.0561 15.2345 13.805 14.6145 14.3471C13.9945 14.8893 13.1986 15.1878 12.375 15.1872C9.83887 15.1872 7.40661 14.1797 5.61329 12.3864C3.81998 10.5931 2.8125 8.16084 2.8125 5.62471C2.81187 4.80107 3.1104 4.00524 3.65257 3.38521C4.19474 2.76518 4.94364 2.36317 5.76 2.25393C5.88068 2.23959 6.00276 2.26472 6.10796 2.32556C6.21316 2.3864 6.29583 2.47968 6.34359 2.59143L7.8293 5.91018C7.8658 5.99542 7.88067 6.08836 7.87257 6.18073C7.86447 6.2731 7.83367 6.36204 7.78289 6.43963L6.28031 8.22627C6.22701 8.3067 6.1955 8.39958 6.18884 8.49583C6.18219 8.59208 6.20062 8.68842 6.24234 8.77541C6.82383 9.9658 8.0543 11.1815 9.2482 11.7574C9.33566 11.7989 9.43243 11.8169 9.52898 11.8097C9.62553 11.8024 9.71851 11.7701 9.79875 11.7159L11.5587 10.2189Z",
    stroke: "#7043FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6191_15481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconPurple);
export default __webpack_public_path__ + "static/media/phone_icon_purple.328f24daade6c68ee11c4ac39722cdd5.svg";
export { ForwardRef as ReactComponent };